import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import BootstrapMenuBar from "./components/menu/BootstrapMenuBar";
import TSExpert from "./components/ts-expert/TSExpert";
import LiveList from "./components/LiveList";
import Inventory from "./components/Inventory";
import TopologyWorkspace from "./components/topology/TopologyWorkspace";
import NetworkTraffic from "./components/NetworkTraffic";
import EventLog from "./components/EventLog";
import Login from "./components/login-config/Login";
import LoginHandler from "./components/login-config/LoginHandler";
import Report from "./components/login-config/Report";
import ChangeLogin from "./components/login-config/ChangeLogin";
import Configuration from "./components/login-config/Configuration";
import Blacklist from "./components/login-config/Blacklist";
import EditGSDML from "./components/login-config/EditGSDML";
import Sweep from "./components/login-config/Sweep";
import WLANConfig from "./components/login-config/WLANConfig";
import EthernetConfig from "./components/login-config/EthernetConfig";
import OfficeEthernetConfig from "./components/login-config/OfficeEthernetConfig";
import TsExpertConfig from "./components/login-config/TsExpertConfig";
import EditTags from "./components/login-config/EditTags";
import Constants from "./components/utilities/Constants";

class App extends Component {

  componentDidMount = async () => {
    if (localStorage.getItem(Constants.LL_ACTIVE_COLUMNS) === null) {
      localStorage.setItem(Constants.LL_ACTIVE_COLUMNS, JSON.stringify({
        name: true, tag: true, mac: true, ip: true, alarms: true, faults: true,
        ping: true, lostPackets: true, availability: true, status: true
      }));
    }

    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      let language = await fetch(Constants.REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.language);

      localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
      window.location.reload();
    }

    let ethernetPresent = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiOrEthernet", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.ethernetPresent);

    sessionStorage.setItem(Constants.WIFI_OR_ETHENET_KEY, ethernetPresent);
  }

  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App" style={wholeAppStyle}>
          <BootstrapMenuBar />
          <div style={mainAppContentStyle}>
            <Route exact path="/" component={TSExpert} />
            <Route exact path="/livelist" component={LiveList} />
            <Route exact path="/livelist/:ip" component={LiveList} />
            <Route path="/inventory" component={Inventory} />
            <Route path="/topology" component={TopologyWorkspace} />
            <Route path="/graphic-topology" component={TopologyWorkspace} />
            <Route path="/traffic" component={NetworkTraffic} />
            <Route path="/log" component={EventLog} />
            <Route path="/config" component={Configuration} />
            <Route path="/login" component={Login} />
            <Route path="/login-handler" component={LoginHandler} />
            <Route path="/report" component={Report} />
            <Route path="/change-login" component={ChangeLogin} />
            <Route path="/blacklist" component={Blacklist} />
            <Route path="/edit-gsdml" component={EditGSDML} />
            <Route path="/sweep" component={Sweep} />
            <Route path="/wlan-config" component={WLANConfig} />
            <Route path="/ethernet-config" component={EthernetConfig} />
            <Route path="/office-ethernet-config" component={OfficeEthernetConfig} />
            <Route path="/ts-expert-config" component={TsExpertConfig} />
            <Route path="/tags" component={EditTags} />
          </div>
        </div>
      </Router>
    );
  }
}

// CSS Custom App Margins
const wholeAppStyle = {
  height: "100%"
};

const mainAppContentStyle = {
  marginLeft: "24px",
  marginRight: "24px",
  marginBottom: "24px",
  marginTop: "8px"
};

export default App;
